import axios, { AxiosInstance, AxiosError, AxiosRequestConfig } from "axios";

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  _retryWithHttp?: boolean;
}

const BASE_URL = process.env.VUE_APP_API_KEY;

const api: AxiosInstance = axios.create({
  baseURL: BASE_URL,
});

api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as CustomAxiosRequestConfig;

    if (
      error.code === "ERR_NETWORK" &&
      BASE_URL?.startsWith("https://") &&
      !originalRequest._retryWithHttp
    ) {
      const fallbackURL = BASE_URL.replace(/^https:/, "http:");
      originalRequest.baseURL = fallbackURL;
      originalRequest._retryWithHttp = true;

      const fallbackInstance = axios.create({
        baseURL: fallbackURL,
      });

      return fallbackInstance(originalRequest);
    }

    return Promise.reject(error);
  }
);

export default api;
